

import { createPopper } from '@popperjs/core';

export default {
  data () {
    return {
      id: null,
      popper: null
    };
  },
  computed: {
    tooltipId () {
      return 'tooltip-' + this.id;
    },
    contentId () {
      return 'content-' + this.id;
    }
  },
  mounted () {
    this.id = this._uid;
    const tooltip = this.$refs.tooltip;
    const content = this.$refs.content;
    this.popper = createPopper(content, tooltip);
  },
  beforeDestroy () {
    if (this.popper) {
      this.popper.destroy();
      this.popper = null;
    }
  },
  methods: {
    show () {
      this.$refs.tooltip.setAttribute('data-show', '');
    },
    hide () {
      this.$refs.tooltip.removeAttribute('data-show');
    }
  }
};
